<span *ngFor="let color of colors" [matTooltip]="color.ColorText">
  <span class=circle  [style.backgroundColor]="color.ColorCode"></span>
</span>